<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_23089_17396)">
  <path d="M6.75 11.25C6.75 11.25 7.59375 12 9 12C10.4062 12 11.25 11.25 11.25 11.25M12.75 7.5C12.75 7.91421 12.4142 8.25 12 8.25C11.5858 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM6.75 7.5C6.75 7.91421 6.41421 8.25 6 8.25C5.58579 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 5.58579 6.75 6 6.75C6.41421 6.75 6.75 7.08579 6.75 7.5Z" stroke="#0F9130" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_23089_17396">
  <rect width="18" height="18" fill="white"/>
  </clipPath>
  </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>